import { render, staticRenderFns } from "./MessageTree.vue?vue&type=template&id=778ea929&"
import script from "./MessageTree.vue?vue&type=script&lang=js&"
export * from "./MessageTree.vue?vue&type=script&lang=js&"
import style0 from "./MessageTree.vue?vue&type=style&index=0&id=778ea929&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports